import FormattedMessage from 'I18n/components/FormattedMessage';
import UICheckbox from 'UIComponents/input/UICheckbox';
import Small from 'UIComponents/elements/Small';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import useBulkActions from 'framework-listing-lib/hooks/useBulkActions';
import { useIsGalleryMode } from 'framework-listing-lib/internal/hooks/useUIMode';
import { useHasSearchInput } from 'framework-listing-lib/internal/hooks/useSearchInputProps';
import { BULK_SELECTION_MODE } from 'framework-listing-lib/constants/table';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function BulkActions({
  bulkActionProps,
  hasBulkActions,
  isTableActionsOpen,
  selectedObjectsCount,
  selectionMode,
  onSelectRows
}) {
  const renderBulkActionProps = useBulkActions();
  const isGalleryMode = useIsGalleryMode();
  const hasSearchInput = useHasSearchInput();
  return /*#__PURE__*/_jsxs(Flex, {
    "data-test-id": "crm-table-bulk-actions",
    alignItems: "center",
    flexGrow: 1,
    gap: "250",
    children: [isTableActionsOpen && isGalleryMode && /*#__PURE__*/_jsx(UICheckbox, {
      onChange: ({
        target: {
          checked
        }
      }) => onSelectRows && onSelectRows(checked),
      checked: selectionMode && [BULK_SELECTION_MODE.ALL, BULK_SELECTION_MODE.ALL_ON_PAGE].includes(selectionMode),
      indeterminate: selectionMode === BULK_SELECTION_MODE.PARTIAL,
      "data-test-id": "gallery-mode-select-all-checkbox"
    }), isTableActionsOpen && /*#__PURE__*/_jsxs(View, {
      as: "span",
      "data-test-id": "crm-listing-bulk-actions",
      paddingInlineStart: hasSearchInput ? '0' : '250',
      children: [/*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkListingLib.header.actions.selected",
          options: {
            count: selectedObjectsCount
          }
        })
      }), hasBulkActions && bulkActionProps && bulkActionProps.renderBulkActions ? /*#__PURE__*/_jsx(Small, {
        children: bulkActionProps.renderBulkActions(renderBulkActionProps)
      }) : null]
    })]
  });
}